import actions from '~/store/modules/shared/dealers/site/actions'
import getters from '~/store/modules/shared/dealers/site/getters'
import mutations from '~/store/modules/shared/dealers/site/mutations'
import state from '~/store/modules/shared/dealers/site/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
